export const TRIAL_STATUS = 'trial';
export const TRIAL_SUBSCRIBED_STATUS = 'trial_subscribed';
export const SUBSCRIBED_STATUS = 'subscribed';
export const EXPIRED_STATUS = 'expired';
export const EXCEEDED_STATUS = 'exceeded';

// PACKAGE TYPE
export const PACKAGE_NAME01 = 'launch';
export const PACKAGE_NAME02 = 'convert';
export const PACKAGE_NAME03 = 'accelerate';
export const ENTERPRISE = 'enterprise';

// DEFAULT PACKAGE DATA
export const DEFAULT_PACKAGE_DATA = [
  {
    mainTier: 'launch',
    gmvMin: 0,
    gmvMax: 50000,
    subTiers: [
      {
        mainTier: 'launch',
        tier: 1,
        planId: 'launch_1',
        gmvMin: 0,
        gmvMax: 5000,
        pricing: 29
      },
      {
        mainTier: 'launch',
        tier: 2,
        planId: 'launch_2',
        gmvMin: 5001,
        gmvMax: 15000,
        pricing: 99
      },
      {
        mainTier: 'launch',
        tier: 3,
        planId: 'launch_3',
        gmvMin: 15001,
        gmvMax: 50000,
        pricing: 159
      }
    ]
  },
  {
    mainTier: 'convert',
    gmvMin: 50001,
    gmvMax: 400000,
    subTiers: [
      {
        mainTier: 'convert',
        tier: 4,
        planId: 'convert_4',
        gmvMin: 50001,
        gmvMax: 100000,
        pricing: 299
      },
      {
        mainTier: 'convert',
        tier: 5,
        planId: 'convert_5',
        gmvMin: 100001,
        gmvMax: 250000,
        pricing: 499
      },
      {
        mainTier: 'convert',
        tier: 6,
        planId: 'convert_6',
        gmvMin: 250001,
        gmvMax: 400000,
        pricing: 599
      }
    ]
  },
  {
    mainTier: 'accelerate',
    gmvMin: 400001,
    gmvMax: 2500000,
    subTiers: [
      {
        mainTier: 'accelerate',
        tier: 7,
        planId: 'accelerate_7',
        gmvMin: 400001,
        gmvMax: 650000,
        pricing: 699
      },
      {
        mainTier: 'accelerate',
        tier: 8,
        planId: 'accelerate_8',
        gmvMin: 650001,
        gmvMax: 1000000,
        pricing: 799
      },
      {
        mainTier: 'accelerate',
        tier: 9,
        planId: 'accelerate_9',
        gmvMin: 1000001,
        gmvMax: 2500000,
        pricing: 1499
      }
    ]
  }
];
